import { render, staticRenderFns } from "./location-image.vue?vue&type=template&id=261b34c8&scoped=true&"
import script from "./location-image.vue?vue&type=script&lang=js&"
export * from "./location-image.vue?vue&type=script&lang=js&"
import style0 from "./location-image.vue?vue&type=style&index=0&id=261b34c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261b34c8",
  null
  
)

export default component.exports